import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRingComponent } from './simple-icons-ring.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRingComponent ],
    exports:      [ SimpleIconsRingComponent ],
    bootstrap:    []
})
export class SimpleIconsRingModule {}
